
/**
 *
 * @param {string} type hash/history default 'history'
 * @return {object} query params object
 */
 export const getUrlParams = (type) => {
  const queryString = type === 'hash' ? window.location.hash.split('?')[1] : window.location.search.substr(1);
  if (!queryString) return {};
  const queryList = queryString.split('&')?.filter(Boolean);

  const paramsObj = queryList.reduce((prev, query) => {
    const [queryKey, queryValue] = query.split('=');
    return { ...prev, [queryKey]: decodeURIComponent(queryValue || '') };
  }, {});
  return paramsObj;
};

export const closeModel = (msg) => window.parent.postMessage(
  {
    msgCode: getUrlParams().messageCode,
    Code: 200,
    Message: msg,
    isClose: true,
  },
  '*',
);